import React, { useEffect } from 'react';
import { useAlertStore } from 'src/ui/common/alert/AlertStore';

type AlertProps = {
  customStyles?: string;
};

const InlineAlert: React.FC<AlertProps> = ({ customStyles }) => {
  const { inlineContent, hideAlert } = useAlertStore();

  useEffect(() => {
    if (typeof inlineContent === 'string') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [inlineContent]);

  useEffect(() => {
    hideAlert();
  }, [hideAlert]);

  if (inlineContent == null) return null;

  return (
    <div className={customStyles ?? 'mb-2 text-center text-xl text-red-500'}>{inlineContent}</div>
  );
};

export default InlineAlert;
